import React from 'react'
import cx from 'classnames'
import { useAppSelector } from 'reduxTyped'

import { AiAutomationLayoutSelectors } from 'apps/aiAutomation/store/layout'

import cm from './Content.module.css'

interface ContentProps {
  children: React.ReactNode
}

export const Content = ({ children }: ContentProps) => {
  const isSidebarOpen = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarOpen)

  return (
    <div className={cm.layoutContentWrapper}>
      <main
        className={cx(cm.layoutContent, {
          [cm.layoutContent_muted]: isSidebarOpen,
        })}
        // @ts-expect-error type for inert is supported starting from React 19+
        // It's also not working for now when we pass true/false, that's why there is an empty string and undefined values
        inert={isSidebarOpen ? '' : undefined}
      >
        {children}
      </main>
    </div>
  )
}
